import clsxm from "immigram-ui-cmon/src/lib/clsxm";

export const DashedBlock = ({
  className,
  children,
  ...props
}: React.HTMLProps<HTMLDivElement>) => {
  return (
    <div
      className={clsxm("group/dashed relative overflow-hidden", className)}
      {...props}
    >
      <div
        className="group-hover/dashed:bg-gray-100 group-hover/dashed:!bg-none absolute inset-0 transition"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='16' ry='16' stroke='%23d9e0eb' stroke-width='1.5' stroke-dasharray='8%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e\")",
        }}
      />
      <div className="relative h-full w-full">{children}</div>
    </div>
  );
};
